import { useTranslation } from 'react-i18next'
import { SVGs } from '../../../../assets'
import { BitazzaText } from '../../../../components'
import styles from './styles.module.scss'
import { Divider } from 'antd'
import { FC } from 'react'

interface Props {
    onConfirmHandler: () => void
}

export const NotLinkedFdw: FC<Props> = ({ onConfirmHandler }) => {
    const { t } = useTranslation()

    const claimSteps = [
        {
            title: t('Download Freedom World application '),
            subTitle: t('here'),
        },
        {
            title: t('Register an account '),
            subTitle: t(
                'Open the application and register in a few easy steps.'
            ),
        },
        {
            title: t('Go to "Account" menu '),
            subTitle: t('It’s located on the bottom right of the screen.'),
        },
        {
            title: t('Select "Bitazza Connect"'),
            subTitle: t(
                'Once you have connected your Freedom World with Bitazza, come back here at Bitazza Mocking Trade to redeem your NFT.'
            ),
        },
        {
            title: t('Click "Claim NFT Reward" again'),
            subTitle: t('The NFT will send to your  Freedom World.'),
        },
    ]
    return (
        <div className={styles.container}>
            <div className={styles.titleWrapper}>
                <img src={SVGs.freedomWorld} alt="freedom-wallet" />
                <BitazzaText
                    content={t('Please follow these steps to claim your NFT')}
                    color="#fff"
                    format="t20"
                    textAlign="center"
                    bold
                />

                <Divider className={styles.divider} />
                <div className={styles.stepsWrapper}>
                    {claimSteps.map((step, index) => (
                        <div key={index} className={styles.steps}>
                            <BitazzaText
                                color="#F1D87E"
                                content={index + 1}
                                format="t16"
                                bold
                            />

                            {index === 0 ? (
                                <div>
                                    <div className={styles.fistIndex}>
                                        <BitazzaText
                                            color="#FFFFFF"
                                            content={step.title}
                                            format="t16"
                                            bold
                                        />

                                        <a
                                            href="https://bitazza.onelink.me/lhpw/hrvgisor"
                                            style={{
                                                fontSize: '16px',
                                                color: '#F1D87E',
                                                fontWeight: 'bold',
                                                textDecoration: 'underline',
                                            }}
                                        >
                                            {step.subTitle}
                                        </a>
                                    </div>
                                </div>
                            ) : (
                                <div className={styles.stepTitle}>
                                    <BitazzaText
                                        color="#FFFFFF"
                                        content={step.title}
                                        format="t16"
                                        bold
                                    />

                                    <BitazzaText
                                        color="#86A1A1"
                                        content={step.subTitle}
                                        format="t16"
                                    />
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <div
                    className={styles.confirmButton}
                    onClick={onConfirmHandler}
                >
                    <BitazzaText
                        format="t18"
                        color="#000"
                        content={t('I got it')}
                        bold
                    />
                </div>
            </div>
        </div>
    )
}
